import type { TNetworkStore } from '../networkStore'

export const selectors = {
  getConnectionStatus: (state: TNetworkStore) => state.connectionStatus,
  getNetworkStatusNotification: (state: TNetworkStore) => state.networkStatusNotification,
}
